<template>
    <div class="page" id="playerBook">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Booking confirmation</h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="goToLessons" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <div v-if="lesson">
                <span
                    class="pay"
                    v-if="!lesson.guest_name"
                    :class="{ credits: lesson.payment_type == 'credits' }"
                >
                    {{ lesson.payment_type == "on_day" ? "Pay on day" : "Paid" }}
                </span>

                <span v-if="isPro" class="info white mb10">
                    <span v-if="lesson.guest_name">{{ lesson.guest_name }}</span>

                    <span v-else>
                        {{ lesson.player.first_name }}
                        {{ lesson.player.last_name }}
                        <router-link
                            :to="{
                                name: 'proPlayer',
                                params: { id: lesson.player.id },
                            }"
                            class="player_link"
                            ><img src="~@/assets/icons/profile.svg"
                        /></router-link>
                    </span>
                </span>

                <span class="info white">
                    {{ $date(lesson.date).format("DD MMM YYYY") }}

                    <template v-if="lesson.start != lesson.end">
                        {{ $date("2020-12-08 " + lesson.start).format("HH:mm") }}
                        -
                        {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
                    </template>

                    <router-link
                        v-if="isPro"
                        @click.native.prevent=""
                        :to="{
                            name: 'proLessonDiarySetting',
                            params: {
                                start: $date(lesson.date).format('YYYY-MM-DD'),
                                end: $date(lesson.date).format('YYYY-MM-DD'),
                            },
                        }"
                        class="date_link"
                        ><img src="~@/assets/icons/calendar.svg"
                    /></router-link>
                </span>

                <button
                    class="button half dark"
                    @click.prevent="changeLesson"
                    type="button"
                    name="button"
                >
                    Change
                </button>
                <button
                    class="button half red"
                    @click.prevent="cancelLesson"
                    type="button"
                    name="button"
                >
                    Cancel lesson
                </button>
                <br />
                <br />
                <br />

                <empty-placeholder class="warning mt10">
                    IMPORTANT! Once a booking has been placed a cancellation will only be accepted
                    with a minumum of 24 hours notice before the lesson is due to commence. Full
                    payment will be due for lessons cancelled after this period.
                </empty-placeholder>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
export default {
    name: "book-lesson-confirmation",
    components: { EmptyPlaceholder, XIcon, FadeImage },
    created() {
        this.getLesson();
    },
    data() {
        return {
            lesson: false,
        };
    },
    computed: {
        isPro() {
            return this.$store.state.user.type == "pro" ? true : false;
        },
    },
    methods: {
        changeLesson() {
            if (this.isPro) {
                this.$router.push({
                    name: "proLessonChange",
                    params: { id: this.$route.params.id },
                });
            } else {
                this.$router.push({
                    name: "LessonChange",
                    params: { id: this.$route.params.id },
                });
            }
        },
        cancelLesson() {
            var msg = "";
            var TwnetyFourHrs = this.$date().add(24, "hour");
            if (
                this.lesson.payment_type == "credits" &&
                this.$date(this.lesson.date).isBetween(this.$date(), TwnetyFourHrs)
            ) {
                var credits = this.lesson.duration / 15;
                msg =
                    '<br><br><span style="color:#bd6262">There is less than 24 hours before your lesson starts. If you proceed the ' +
                    credits +
                    " credits used to make this booking will not be refunded.</span>";
            }

            this.$confirm(
                "Are you sure you want to cancel this lesson?" + msg,
                () => {
                    window.axios.delete("/lesson/" + this.$route.params.id).then((response) => {
                        if (this.isPro) {
                            this.$router.push({ name: "proLesson" });
                            this.$notify(
                                "This lesson has been cancelled. A notification has been sent to the player",
                            );
                            this.$store.dispatch("updateProLesson", response.data.pro_next_lesson);
                        } else {
                            this.$notify("This lesson has been cancelled.");
                            this.$store.state.user.next_lesson = response.data;
                            this.$router.push({ name: "playerLessons" });
                        }
                    });
                },
                "Yes",
                "No",
            );
        },
        getLesson() {
            window.axios.get("/lesson/" + this.$route.params.id).then((response) => {
                this.lesson = response.data;
            });
        },
        goToLessons() {
            if (this.isPro) {
                this.$router.push({ name: "proLesson" });
            } else {
                this.$router.push({ name: "playerLessons" });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.info {
    position: relative;
    &.white {
        font-size: 16px;
    }
}
.player_link {
    position: absolute;
    width: 24px;
    right: 15px;
    top: 16px;
    img {
        width: 100%;
    }
}
.pay {
    background: $red_1;
    border: 0px;
    padding: 7px 13px;
    display: inline-block;
    margin-bottom: 10px;
    border-radius: 8px;
    color: white;
    font-size: 14px;
    &.credits {
        background: #60c45c;
    }
}

.date_link {
    position: absolute;
    width: 17px;
    right: 21px;
    top: 16px;
    img {
        width: 100%;
    }
}
.confirmation {
    font-size: 14px;
    font-weight: 200;
    line-height: 1.5;
    margin-top: 30px;
    color: $green_0;
}
</style>
